import API from "../api";
import COMMON_API from "@/api/common";

const getDefaultState = () => {
  return {
    listPolicy: [],
    totalPolicy: 0,
    listSituation: [],
    listTaker: [],
    listInsuranceCompany: [],
    listEmission: [],
    listInsured: [],
    currentPolicy: {
      id: null,
      tomador: {
        nome_fantasia: null,
        grupo: {
          nome: null
        }
      },
      solicitada_por: {
        nome: null
      },
      seguradora: {
        nome: null
      },
      submodalidade: {
        nome: null
      },
      situacao: {
        nome: null
      },
      tipo_emissao: {
        nome: null
      }
    },
    listInvoice: [],
    totalInvoice: 0,
    currentInvoice: {},
    listTypeEndorsement: [],
    cancelItems: [],
    currentEndorsement: {},
    currentPolicyEdit: {},
    inactivateItems: [],
    currentRequestEndorsement: {},
    itemsEndorsement: []
  }
}

const state = getDefaultState();

export default {
  namespaced: true,
  state,
  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
    setCurrentPolicyId(state, policy_id) {
      state.currentPolicy.id = policy_id;
    },
    setListPolicy(state, payload) {
      state.listPolicy = payload.items;
      state.totalPolicy = payload.total_count;
    },
    setListSituation(state, payload) {
      state.listSituation = payload;
    },
    setListTaker(state, payload) {
      state.listTaker = payload;
    },
    setListInsuranceCompany(state, payload) {
      state.listInsuranceCompany = payload;
    },
    setListEmission(state, payload) {
      state.listEmission = payload;
    },
    setListInsured(state, payload) {
      state.listInsured = payload;
    },
    setCurrentPolicy(state, payload) {
      state.currentPolicy = payload;
    },
    setListInvoice(state, payload) {
      state.listInvoice = payload.items;
      state.totalInvoice = payload.total_count;
    },
    setCurrentInvoice(state, payload) {
      state.currentInvoice = payload;
    },
    setListTypeEndorsement(state, payload) {
      state.listTypeEndorsement = payload;
    },
    setCancelItems(state, payload) {
      state.cancelItems = payload;
    },
    setCurrentEndorsement(state, payload) {
      state.currentEndorsement = payload;
    },
    setCurrentPolicyEdit(state, payload) {
      state.currentPolicyEdit = payload;
    },
    setInactivateItems(state, payload) {
      state.inactivateItems = payload;
    },
    setCurrentRequestEndorsement(state, payload) {
      state.currentRequestEndorsement = payload;
    },
    setItemsEndorsement(state, payload) {
      state.itemsEndorsement = payload;
    }
  },
  actions: {
    resetState ({ commit }) {
      commit('resetState');
    },
    setCurrentPolicyId({ commit }, policy_id) {
      commit('setCurrentPolicyId', policy_id);
    },
    async requestListPolicy({ commit }, payload) {
      const { data } = await API.getListPolicy(payload);
      commit("setListPolicy", data);
      return data;
    },
    async requestListSituation({ commit }) {
      const { data } = await API.getSituation();
      commit("setListSituation", data);
      return data;
    },
    async requestListTaker({ commit }, payload) {
      const { data } = await COMMON_API.getTaker(payload);
      commit("setListTaker", data);
      return data;
    },
    async requestListInsuranceCompany({ commit }) {
      const { data } = await COMMON_API.getInsuranceCompanies();
      commit("setListInsuranceCompany", data);
      return data;
    },
    async requestListEmission({ commit }) {
      const { data } = await API.getEmission();
      commit("setListEmission", data);
      return data;
    },
    async requestInsuredByNameOrNumber({ commit }, payload) {
      const { data } = await API.getInsured(payload);
      commit("setListInsured", data);
      return data;
    },
    async requestNewPolicy(context, payload) {
      const { data } = await API.postPolicy(payload);
      return data;
    },
    async requestCurrentPolicy({ commit }, payload) {
      const { data } = await API.getCurrentPolicy(payload);
      commit("setCurrentPolicy", data);
      return data;
    },
    async requestEditPolicy(context, payload) {
      const { data } = await API.putPolicy(payload);
      return data;
    },
    async requestListInvoice({ commit }, payload) {
      const { data } = await API.getListInvoice(payload);
      commit("setListInvoice", data);
      return data;
    },
    async requestNewInvoice(context, payload) {
      const { data } = await API.postInvoice(payload);
      return data;
    },
    async requestCurrentInvoice({ commit }, payload) {
      const { data } = await API.getCurrentInvoice(payload);
      commit("setCurrentInvoice", data);
      return data;
    },
    async requestEditInvoice(context, payload) {
      const { data } = await API.putInvoice(payload);
      return data;
    },
    async requestListTypeEndorsement({ commit }) {
      const { data } = await API.getListTypeEndorsement();
      commit("setListTypeEndorsement", data);
      return data;
    },
    async requestNewEndorsement(context, payload) {
      const { data } = await API.postEndorsement(payload);
      return data;
    },
    async requestCancelItems({ commit }, payload) {
      const { data } = await COMMON_API.suggestCancelItems(payload);
      commit("setCancelItems", data);
      return data;
    },
    async requestEditEndorsement(context, payload) {
      const { data } = await API.putEndorsement(payload);
      return data;
    },
    async requestCurrentEndorsement({ commit }, payload) {
      const { data } = await API.getCurrentEndorsement(payload);
      commit("setCurrentEndorsement", data);
      return data;
    },
    async requestCurrentPolicyEdit({ commit }, payload) {
      const { data } = await API.getCurrentPolicyEdit(payload);
      commit("setCurrentPolicyEdit", data);
      return data;
    },
    async requestInactivateInvoice(context, payload) {
      const { data } = await API.putInactivateInvoice(payload);
      return data;
    },
    async requestInactivateItems({ commit }) {
      const { data } = await API.getInactivateItems();
      commit("setInactivateItems", data);
      return data;
    },
    async requestCancelPolicy(context, payload) {
      const { data } = await API.postCancelPolicy(payload);
      return data;
    },
    async requestRefuseCancelPolicy(context, payload) {
      const { data } = await API.postRefuseCancelPolicy(payload);
      return data;
    },
    async requestNewRequestEndorsement(context, payload) {
      const { data } = await API.postRequestEndorsement(payload);
      return data;
    },
    async requestCurrentRequestEndorsement({ commit }, payload) {
      const { data } = await API.getCurrentRequestEndorsement(payload);
      commit("setCurrentRequestEndorsement", data);
      return data;
    },
    async requestEditRequestEndorsement(context, payload) {
      const { data } = await API.putRequestEndorsement(payload);
      return data;
    },
    async requestItemsEndorsement({ commit }, payload) {
      const { data } = await API.getItemsEndorsement(payload);
      commit("setItemsEndorsement", data);
      return data;
    },
    async requestCriticismEndorsement(context, payload) {
      const { data } = await API.getCriticismEndorsement(payload);
      return data;
    },
    async requestResolveCriticismEndorsement(context, payload) {
      const { data } = await API.putResolveCriticismEndorsement(payload);
      return data;
    },
    async requestResendCriticismEndorsement(context, payload) {
      const { data } = await API.postResendCriticismEndorsement(payload);
      return data;
    },
    async requestNewCriticismEndorsement(context, payload) {
      const { data } = await API.postCriticismEndorsement(payload);
      return data;
    },
    async requestCancelRequestEndorsement(context, payload) {
      const { data } = await API.postCancelRequestEndorsement(payload);
      return data;
    },
    async requestOptionsPolicy(context, payload) {
      const { data } = await API.getOptionsPolicy(payload);
      return data;
    }
  },
  modules: {}
};
